module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-html-m-b-20"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.label) + ":")])]), _vm._v(" "), _c('markdown-editor', {
    ref: "markdownEditor",
    attrs: {
      "configs": _vm.editor.config,
      "value": _vm.html2,
      "custom-theme": true
    },
    on: {
      "input": _vm.handleInput
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1452d250","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./Content/Modern/js/vue/_block-html.vue
// module id = 113
// module chunks = 1